const line = document.querySelector(
  '.development-process-animation__line-hover',
);
const points = Array.from(
  document.querySelectorAll(
    'span.development-process-animation__line-one-point, span.development-process-animation__line-two-point, span.development-process-animation__line-three-point, span.development-process-animation__line-four-point, span.development-process-animation__line-five-point',
  ),
);
const numbers = Array.from(
  document.querySelectorAll(
    'span.development-process-animation__line-one-number, span.development-process-animation__line-two-number, span.development-process-animation__line-three-number, span.development-process-animation__line-four-number, span.development-process-animation__line-five-number',
  ),
);
const texts = Array.from(
  document.querySelectorAll(
    'span.development-process-animation__line-one-text, span.development-process-animation__line-two-text, span.development-process-animation__line-three-text, span.development-process-animation__line-four-text, span.development-process-animation__line-five-text',
  ),
);

function isInViewport(element) {
  if (!element) return;
  const rect = element.getBoundingClientRect();
  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <=
      (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
}
// console.log(line.getBoundingClientRect())
document.addEventListener(
  'scroll',
  function () {
    if (!line) return;
    const messageText = isInViewport(line)
      ? 'The box is visible in the viewport'
      : 'The box is not visible in the viewport';

    //run line
    if (messageText) {
      setTimeout(() => {
        line.style.animationPlayState = 'running';

        const ellements = [...points, ...texts, ...numbers];
        // console.log(ellements)
        ellements.map(el =>
          el && el.style ? (el.style.animationPlayState = 'running') : null,
        );
      }, 1000);
    }
  },
  {
    passive: true,
  },
);
